import styled from "styled-components";

export const InfoBlock = styled.div`
  width: min(92%, 1280px);
  margin: 100px auto 0;
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
  gap: 40px;
  align-items: center;

  @media (max-width: 1024px) {
      grid-template-columns: 1fr;
      gap: 60px;
      margin-top: 60px;
  }

  @media (max-width: 600px) {
      margin-top: 40px;
      gap: 50px;
  }
`;

export const ImageBlock = styled.div`
  border-radius: var(--radius-xl);
  width: 100%;
  aspect-ratio: 16 / 11;
  border: 6px solid var(--color-primary);
  box-shadow: var(--shadow-md);
  background-size: cover !important;
  background-position: center !important;

  @media (max-width: 600px) {
      border: 4px solid var(--color-primary);
      aspect-ratio: 4 / 3;
  }
`;

export const TextBlock = styled.div`
  background: white;
  border: 6px solid var(--color-primary);
  border-radius: var(--radius-xl);
  width: 100%;
  position: relative;
  font-size: 18px;
  line-height: 1.6;
  font-weight: 400;
  color: var(--color-text);
  padding: 48px 40px 40px;
  box-shadow: var(--shadow-sm);

  @media (max-width: 1300px) {
      font-size: 15px;
      padding: 44px 28px 28px;
  }

  @media (max-width: 600px) {
      border: 4px solid var(--color-primary);
      padding: 48px 22px 22px;
  }
`;

export const MobileText = styled.div``;

export const HeadText = styled.div`
  position: absolute;
  background: white;
  color: var(--color-primary);
  font-size: 36px;
  line-height: 1.2;
  font-weight: 800;
  top: -28px;
  left: 24px;
  padding: 0 14px;
  max-width: calc(100% - 48px);

  @media (max-width: 1024px) {
      font-size: 28px;
      top: -22px;
  }

  @media (max-width: 600px) {
      font-size: 22px;
      top: -18px;
      left: 16px;
  }
`;
